<template>
  <div class="gyzhmain">
    <!-- 大图 -->
    <div class="bigbgi">
      <div class="midbgi">
      </div>
    </div>
    <div class="gyzgcont">

      <el-row>
        <el-col :span="5">
          <div class="cdtitle">观众中心</div>
          <el-menu @select="handleSelect" :default-active="pageNum" class="gyzhcd  el-menu-vertical-demo" text-color="#000" active-text-color="#1D50A2">

            <el-menu-item index="2" @click="cgdj">参观登记</el-menu-item>
            <el-menu-item index="3">观众常见问题</el-menu-item>
          </el-menu>

          <!-- 展出时间 -->
          <div class="zcsj">
            展出时间
          </div>
          <div>
            <div class="rqys">
              <div class="greendian"></div>
              <div class="rcsj">
                2026年6月2日 9:00-17:00
              </div>
            </div>
            <div class="rqys">
              <div class="greendian"></div>
              <div class="rcsj">
                2026年6月3日 9:00-17:00
              </div>
            </div>
            <div class="rqys">
              <div class="greendian"></div>
              <div class="rcsj">
                2026年6月4日 9:00-16:00
              </div>
            </div>
            <div style="margin-bottom:30px" class="rcsj">
              （每日闭馆前1小时停止入场）
            </div>
          </div>
        </el-col>
        <el-col :span="18">
          <div class="bread">
            <div>
              <a href="https://www.ciepec-online.com:8086/"> 首页>></a>
            </div>
            <div>观众中心</div>
          </div>

          <div style="padding:0 30px" v-if="menuName=='参观登记'||pageNum==2">
            <img style="width:100%" src="../../assets/index/展会介绍.jpg" alt="">
          </div>
          <div style="padding:0 30px" v-if="menuName=='观众常见问题'||pageNum==3">
            <img style="width:100%;margin-top:10px" src="../../assets/index/zsdy.jpg" alt="">
            <div style="font-weight:600;font-size: 26px;color: #3d9b35;margin-top:30px;margin-bottom:20px">我们为您列举了参观的常见问题，帮您轻松解答疑惑。</div>
            <div class="question">
              <el-collapse class="collapse" v-model="activeNames">
                <el-collapse-item title="展会的观众开放时间？" name="1">
                  <div>2026年6月2日 9：00-17:00</div>
                  <div>2026年6月3日 9：00-17:00</div>
                  <div>2026年6月4日 9：00-16:00</div>
                  <div>（每日闭馆前1小时停止入场）</div>
                </el-collapse-item>
                <el-collapse-item title="展会的举办地点？" name="2">
                  <div>北京.中国国际展览中心（朝阳馆）</div>
                </el-collapse-item>
                <el-collapse-item title="参观是否收费？" name="3">
                  <div>本届展会免费参观，不收取任何费用</div>
                </el-collapse-item>
                <el-collapse-item title="如何获取参观证？" name="4">
                  <div>观众凭注册二维码入场参观，无需参观证</div>
                </el-collapse-item>
                <el-collapse-item title="谁可以来参观展会？" name="5">
                  <div>展会主要是面向环保行业的从业人员，同时欢迎非环保领域的同仁到场参观，共建绿色家园。</div>
                </el-collapse-item>
              </el-collapse>
            </div>
          </div>

        </el-col>
      </el-row>

    </div>
  </div>
</template>

<script>
export default {
  name: 'Gyzh',
  data () {
    return {
      menuName: '目标观众',
      pageNum: '1',
      activeNames: []
    }
  },
  methods: {
    handleSelect (key) {
      this.menuName = event.target.innerText.trim()
      this.pageNum = key
      // if (this.pageNum == 6) {
      //   window.location.href = 'https://www.ciepec-online.com/'
      // }
    },
    cgdj () {
      window.location.href = 'https://data.ciec.com.cn/c2l0ZTo1OTI5Mzk/p/v/register'
    }
  }
}
</script>

<style scoped>
.gyzhmain {
  width: 100%;
}
.bigbgi {
  background-image: url('../../assets/index/banner-2026.jpg');
  background-repeat: no-repeat;
  background-position: center top;
  background-size: cover;
  width: 100%;
  height: 0;
  padding-bottom: 27.87%;
  margin-bottom: 60px;
}
.midbgi {
  background-image: none;
  width: 100%;
}
.gyzgcont {
  width: 80%;
  margin: 0 auto;
}

.gyzhcd {
  background: url('../../assets/index/cebian2.png') no-repeat,
    linear-gradient(180deg, #ffffff 0%, #e4efff 100%);
  background-repeat: no-repeat;
  background-position: center bottom;
  background-size: 100%;

  width: 100%;
}
.el-menu-item {
  text-align: center;
  font-size: 18px;
  color: #16181a;
  letter-spacing: -0px;
  text-align: center;
  font-weight: 400;
}
.el-menu-item.is-active {
  font-weight: bold;
  color: #1d50a2;
}
.cdtitle {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: -80px;
  height: 86px;
  color: #fff;
  font-size: 24px;
  color: #ffffff;
  letter-spacing: 0;
  text-align: center;
  font-weight: 700;
  background-image: url('../../assets/index/cebian1.png'); /* 设置图片路径 */
  background-repeat: no-repeat; /* 背景图片不重复 */
  background-position: center; /* 背景图片居中 */
  background-size: cover;
  height: 80px; /* 元素高度 */
  /* width: 100%; */
}
.bread {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: -60px;
  opacity: 0.94;
  background-image: linear-gradient(
    90deg,
    rgba(14, 152, 121, 0) 0%,
    #0e9577 50%
  );
  height: 60px;
  width: 470px;
  float: right;
  font-size: 16px;
  color: #ffffff;
  letter-spacing: 0;
  font-weight: 500;
}
a {
  text-decoration: none;
  font-size: 16px;
  color: #fff;
}
.address {
  opacity: 0.9;
  background: #eff5ff;
  font-size: 18px;
  color: #333333;
  line-height: 34px;
  font-weight: 400;
  padding: 10px;
}
.zcsj {
  margin: 20px 0;
  padding: 10px 0;
  background: #159a7e;
  font-size: 24px;
  color: #ffffff;
  letter-spacing: 0;
  line-height: 24px;
  text-align: center;
  font-weight: 600;
}
.rqys {
  display: flex;
  /* justify-content: space-between; */
  align-items: center;
  height: 40px;
}
.greendian {
  width: 10px;
  height: 10px;
  border-radius: 10px;
  background: #159a7e;
}
.rcsj {
  flex: 1;
  font-size: 18px;
  color: #333333;
  text-align: center;
  line-height: 18px;
  font-weight: 400;
}
.xgtitle {
  width: 280px;
  margin-bottom: 10px;
  margin-top: 5px;
  overflow: hidden; /* 确保超出的内容会被裁剪 */
  white-space: nowrap; /* 确保文本在一行内显示 */
  text-overflow: ellipsis; /* 超出的文本部分显示为省略号 */
  font-size: 18px;
  color: #333333;
  line-height: 32px;
  font-weight: 400;
}
.zhzl {
  font-size: 18px;
  font-weight: normal;
  margin: 0 30px;
  line-height: 45px;
}
h2 {
  text-align: center;
}

.dwname {
  font-size: 18px;
  font-weight: normal;
  margin: 0 30px;
  line-height: 25px;
}

/deep/ .el-collapse-item__header {
  font-size: 18px !important;
  border: none;
  background-color: #f6f4f4f3 !important;
  border-radius: 5px;
  padding: 0 10px;
  height: 50px;
}
/deep/ .el-collapse-item {
  margin-bottom: 20px;
}
/deep/ .el-collapse-item__content {
  font-size: 16px;
  padding: 15px 10px 10px 10px;
  line-height: 32px;
  color: grey !important;
}
/deep/ .el-collapse-item__wrap {
  border: none;
}
.el-collapse {
  border: none;
}
.xz {
  text-decoration: none;
  color: #444;
}
.xz:hover {
  color: #55aa5c;
}
.xztit {
  font-size: 18px;
  line-height: 40px;
}
</style>



// WEBPACK FOOTER //
// src/components/caidan/gzzx.vue